import { callApi } from '@local_modules/generic/fetch.js'

export async function loadAppEntity (accountingOrganisationId) {
  const apiUrl = '/api/accounting-organisation/:accountingOrganisationId'
  const data = callApi(apiUrl, {
    accountingOrganisationId
  })
  return data
}
